/**
 * API Configuration
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const API_ENDPOINTS = {
  UNITS: `${API_BASE_URL}/api/units`,
  UNIT_FILES: (unitName) => `${API_BASE_URL}/api/units/${encodeURIComponent(unitName)}`,
  DOWNLOAD: (encodedPath) => `${API_BASE_URL}/api/download/${encodedPath}`,
  HEALTH: `${API_BASE_URL}/api/health`,
};

export default API_BASE_URL;
